import { useLanguage } from '@/contexts/LanguageContext';
import { languages } from '@/lib/translations';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export function LanguageSelector() {
  const { language, setLanguage } = useLanguage();
  const current = languages.find((l) => l.code === language);

  return (
    <Select value={language} onValueChange={(v) => setLanguage(v as typeof language)}>
      <SelectTrigger className="w-auto h-9 px-2 text-sm border-none bg-transparent hover:bg-accent [&>svg]:hidden" aria-label="Select language">
        <span className="text-lg leading-none">{current?.flag}</span>
      </SelectTrigger>
      <SelectContent>
        {languages.map((l) => (
          <SelectItem key={l.code} value={l.code}>
            <span className="flex items-center gap-2">
              <span className="text-base leading-none">{l.flag}</span>
              {l.label}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
